module.exports = __webpack_public_path__ + "images/9ce5246299630c2fb1dab335605c19d6.png";